import a from "./index205.mjs";
import v from "./index212.mjs";
function f(u, r) {
  v(1, arguments);
  var n = u || {}, s = a(n.start), o = a(n.end), i = o.getTime();
  if (!(s.getTime() <= i))
    throw new RangeError("Invalid interval");
  var m = [], e = s;
  e.setHours(0, 0, 0, 0);
  var t = r && "step" in r ? Number(r.step) : 1;
  if (t < 1 || isNaN(t))
    throw new RangeError("`options.step` must be a number greater than 1");
  for (; e.getTime() <= i; )
    m.push(a(e)), e.setDate(e.getDate() + t), e.setHours(0, 0, 0, 0);
  return m;
}
export {
  f as default
};
//# sourceMappingURL=index260.mjs.map
